import { addDays } from '../format/dates'
import type { OpeningDay } from '../types/site'

/**
 * Wanneer kan een klant komen? Puur: de openingstijden gaan erin, dagen en tijden
 * komen eruit. De webshop geeft de live tijden mee, het beheer het concept dat
 * Sarah aan het bewerken is.
 */

/** Een behandeling duurt met voorbereiding ongeveer anderhalf uur. */
export const SLOT_MINUTES = 90
/** De laatste afspraak begint uiterlijk een uur voor sluiten. */
export const LAST_START_BEFORE_CLOSE = 60
/** Zo ver vooruit zoeken we naar open dagen. */
export const LOOKAHEAD_DAYS = 28

/** Open op deze dag, met een begin- en eindtijd. */
export const isOpen = (d: OpeningDay): d is OpeningDay & { open: string; close: string } => Boolean(d.open && d.close)

/** "09:30" → 570 */
export const toMinutes = (hhmm: string) => {
  const [h = 0, m = 0] = hhmm.split(':').map(Number)
  return h * 60 + m
}

/** 570 → "09:30" */
export const toTime = (minutes: number) => `${String(Math.floor(minutes / 60)).padStart(2, '0')}:${String(minutes % 60).padStart(2, '0')}`

/** Openingsvenster voor een weekdag (0 = zondag). */
export const windowFor = (hours: OpeningDay[], weekday: number) => hours.filter(isOpen).find((h) => h.weekday === weekday)

/** De eerstvolgende `count` dagen waarop de praktijk open is (vanaf morgen). */
export function upcomingOpenDays(hours: OpeningDay[], count: number, from = new Date()): Date[] {
  const days: Date[] = []
  for (let i = 1; days.length < count && i <= LOOKAHEAD_DAYS; i++) {
    const d = addDays(from, i)
    if (windowFor(hours, d.getDay())) days.push(d)
  }
  return days
}

/** Starttijden voor een behandeling op een dag, binnen de openingstijden. */
export function slotsFor(hours: OpeningDay[], day: Date): string[] {
  const w = windowFor(hours, day.getDay())
  if (!w) return []
  const lastStart = toMinutes(w.close) - LAST_START_BEFORE_CLOSE
  const slots: string[] = []
  for (let t = toMinutes(w.open); t <= lastStart; t += SLOT_MINUTES) slots.push(toTime(t))
  return slots
}
